<template>
  <div class="config">
    <b-modal
      ref="formGeneralConfig"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetGeneralConfigPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitGeneralConfig"
      size="sm"
    >
      <h6>{{ generalConfigTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitGeneralConfig">
        <b-form-text id="generalConfigDescriptionText" class="mb-2">
          {{ generalConfigSelected.DESCRIPTION }}
        </b-form-text>
        <b-form-radio-group
          v-if="generalConfigSelected.TYPE == 'boolean'"
          v-model="generalConfigForm.VALUE"
          :options="[
            { text: 'Habilitado', value: '1' },
            { text: 'Desabilitado', value: '0' },
          ]"
          stacked
        ></b-form-radio-group>
        <b-form-input
          v-else
          v-model="generalConfigForm.VALUE"
          :type="generalConfigSelected.TYPE == 'string' ? 'text' : 'number'"
          :step="generalConfigSelected.TYPE == 'decimal' ? '0.1' : '1'"
          placeholder="Valor *"
          aria-describedby="generalConfigValueInputLiveFeedback"
          :state="generalConfigValueState"
          id="generalConfigValueInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="generalConfigSelected.TYPE != 'boolean' && !generalConfigValueState"
          id="generalConfigValueInputLiveFeedback"
        >
          Valor inválido.
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>

    <b-modal
      ref="formAutomationConfig"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetAutomationConfigPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitAutomationConfig"
      size="sm"
    >
      <h6>{{ automationConfigTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitAutomationConfig">
        <b-form-text id="automationConfigDescriptionText" class="mb-2">
          {{ automationConfigSelected.DESCRIPTION }}
        </b-form-text>
        <b-form-radio-group
          v-if="automationConfigSelected.TYPE == 'boolean'"
          v-model="automationConfigForm.VALUE"
          :options="[
            { text: 'Habilitado', value: '1' },
            { text: 'Desabilitado', value: '0' },
          ]"
          stacked
        ></b-form-radio-group>
        <b-form-input
          v-else
          v-model="automationConfigForm.VALUE"
          :type="automationConfigSelected.TYPE == 'string' ? 'text' : 'number'"
          :step="automationConfigSelected.TYPE == 'decimal' ? '0.1' : '1'"
          :min="automationConfigSelected.MIN_VALUE"
          :max="automationConfigSelected.MAX_VALUE"
          placeholder="Valor *"
          aria-describedby="automationConfigValueInputLiveFeedback"
          :state="automationConfigValueState"
          id="automationConfigValueInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="automationConfigSelected.TYPE != 'boolean' && !automationConfigValueState"
          id="automationConfigValueInputLiveFeedback"
        >
          Valor inválido{{ automationConfigRangeHint }}.
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>

    <b-modal
      ref="formProtocolConfig"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetProtocolConfigPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitProtocolConfig"
      size="sm"
    >
      <h6>{{ protocolConfigTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitProtocolConfig">
        <b-form-text id="protocolConfigDescriptionText" class="mb-2">
          {{ protocolConfigSelected.DESCRIPTION }}
        </b-form-text>
        <b-form-radio-group
          v-if="protocolConfigSelected.TYPE == 'boolean'"
          v-model="protocolConfigForm.VALUE"
          :options="[
            { text: 'Habilitado', value: '1' },
            { text: 'Desabilitado', value: '0' },
          ]"
          stacked
        ></b-form-radio-group>
        <b-form-input
          v-else
          v-model="protocolConfigForm.VALUE"
          :type="protocolConfigSelected.TYPE == 'string' ? 'text' : 'number'"
          :step="protocolConfigSelected.TYPE == 'decimal' ? '0.1' : '1'"
          placeholder="Valor *"
          aria-describedby="protocolConfigValueInputLiveFeedback"
          :state="protocolConfigValueState"
          id="protocolConfigValueInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="protocolConfigSelected.TYPE != 'boolean' && !protocolConfigValueState"
          id="protocolConfigValueInputLiveFeedback"
        >
          Valor inválido.
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>

    <b-modal
      ref="formModbusConfig"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetModbusConfigPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitModbusConfig"
      size="sm"
    >
      <h6>{{ modbusConfigTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitModbusConfig">
        <b-form-text id="modbusConfigDescriptionText" class="mb-2">
          {{ modbusConfigSelected.DESCRIPTION }}
        </b-form-text>
        <b-form-radio-group
          v-if="modbusConfigSelected.TYPE == 'boolean'"
          v-model="modbusConfigForm.VALUE"
          :options="[
            { text: 'Habilitado', value: '1' },
            { text: 'Desabilitado', value: '0' },
          ]"
          stacked
        ></b-form-radio-group>
        <b-form-input
          v-else
          v-model="modbusConfigForm.VALUE"
          :type="modbusConfigSelected.TYPE == 'string' ? 'text' : 'number'"
          :step="modbusConfigSelected.TYPE == 'decimal' ? '0.1' : '1'"
          placeholder="Valor *"
          aria-describedby="modbusConfigValueInputLiveFeedback"
          :state="modbusConfigValueState"
          id="modbusConfigValueInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="modbusConfigSelected.TYPE != 'boolean' && !modbusConfigValueState"
          id="modbusConfigValueInputLiveFeedback"
        >
          Valor inválido.
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>

    <b-modal
      ref="formModbusModel"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetModbusModelPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitModbusModel"
      size="sm"
    >
      <h6>{{ modbusModelTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitModbusModel">
        <b-form-text id="modbusModelNameInputLiveHelp">
          <label for="modbusModelNameInput">Nome *</label>
        </b-form-text>
        <b-form-input
          v-model="modbusModelForm.NAME"
          placeholder="Ex.: IF20"
          aria-describedby="modbusModelNameInputLiveHelp modbusModelNameInputLiveFeedback"
          :state="modbusModelNameState"
          maxlength="50"
          id="modbusModelNameInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!modbusModelNameState"
          id="modbusModelNameInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <b-form-text id="modbusModelDescriptionInputLiveHelp">
          <label for="modbusModelDescriptionInput">Descrição *</label>
        </b-form-text>
        <b-form-input
          v-model="modbusModelForm.DESCRIPTION"
          placeholder="Ex.: Inversor METALTEX"
          aria-describedby="modbusModelDescriptionInputLiveHelp modbusModelDescriptionInputLiveFeedback"
          :state="modbusModelDescriptionState"
          maxlength="100"
          id="modbusModelDescriptionInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!modbusModelDescriptionState"
          id="modbusModelDescriptionInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <b-form-text id="modbusModelBaudrateInputLiveHelp">
          <label for="modbusModelBaudrateInput">Baudrate *</label>
        </b-form-text>
        <b-form-select
          v-model="modbusModelForm.BAUDRATE"
          :options="modbusModelBaudrateOptions"
          id="modbusModelBaudrateInput"
        >
        </b-form-select>
        <b-form-text id="modbusModelPidInputLiveHelp" class="mt-2">
          <label>PID</label>
        </b-form-text>
        <b-form-radio-group
          v-model="modbusModelForm.PID"
          :options="[
            { text: 'Habilitado', value: '1' },
            { text: 'Desabilitado', value: '0' },
          ]"
          stacked
        ></b-form-radio-group>
        <b-form-text id="modbusModelTimeoutInputLiveHelp" class="mt-2">
          <label for="modbusModelTimeoutInput">Timeout (ms) *</label>
        </b-form-text>
        <b-form-input
          v-model="modbusModelForm.TIMEOUT"
          type="number"
          min="0"
          max="5000"
          placeholder="0-5000 ms *"
          aria-describedby="modbusModelTimeoutInputLiveHelp modbusModelTimeoutInputLiveFeedback"
          :state="modbusModelTimeoutState"
          id="modbusModelTimeoutInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!modbusModelTimeoutState"
          id="modbusModelTimeoutInputLiveFeedback"
        >
          Valor inválido (0-5000).
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>

    <b-modal
      ref="deleteModbusModel"
      centered
      hide-header
      no-close-on-backdrop
      ok-title="Deletar"
      ok-variant="danger"
      @ok="confirmDeleteModbusModel"
      cancel-title="Cancelar"
      @cancel="resetModbusModelPage"
    >
      <h4>{{ modbusModelTitleDialog }}</h4>
    </b-modal>

    <b-modal
      ref="formI2CConfig"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetI2CConfigPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitI2CConfig"
      size="sm"
    >
      <h6>{{ i2cConfigTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitI2CConfig">
        <b-form-text id="i2cConfigDescriptionText" class="mb-2">
          {{ i2cConfigSelected.DESCRIPTION }}
        </b-form-text>
        <b-form-input
          v-model="i2cConfigForm.VALUE"
          type="text"
          placeholder="Ex.: 0x22"
          aria-describedby="i2cConfigValueInputLiveFeedback"
          :state="i2cConfigValueState"
          id="i2cConfigValueInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!i2cConfigValueState"
          id="i2cConfigValueInputLiveFeedback"
        >
          Valor inválido (formato esperado: 0x00-0xFF).
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>

    <b-modal
      ref="formSDI12Config"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetSDI12ConfigPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitSDI12Config"
      size="sm"
    >
      <h6>{{ sdi12ConfigTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitSDI12Config">
        <b-form-text id="sdi12ConfigDescriptionText" class="mb-2">
          {{ sdi12ConfigSelected.DESCRIPTION }}
        </b-form-text>
        <b-form-input
          v-model="sdi12ConfigForm.VALUE"
          type="number"
          placeholder="Valor *"
          aria-describedby="sdi12ConfigValueInputLiveFeedback"
          :state="sdi12ConfigValueState"
          id="sdi12ConfigValueInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!sdi12ConfigValueState"
          id="sdi12ConfigValueInputLiveFeedback"
        >
          Valor inválido.
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>

    <b-modal
      ref="formSDI12Model"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetSDI12ModelPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitSDI12Model"
      size="sm"
    >
      <h6>{{ sdi12ModelTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitSDI12Model">
        <b-form-text id="sdi12ModelNameInputLiveHelp">
          <label for="sdi12ModelNameInput">Nome *</label>
        </b-form-text>
        <b-form-input
          v-model="sdi12ModelForm.NAME"
          placeholder="Ex.: ACHSDI"
          aria-describedby="sdi12ModelNameInputLiveHelp sdi12ModelNameInputLiveFeedback"
          :state="sdi12ModelNameState"
          maxlength="50"
          id="sdi12ModelNameInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!sdi12ModelNameState"
          id="sdi12ModelNameInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <b-form-text id="sdi12ModelDescriptionInputLiveHelp">
          <label for="sdi12ModelDescriptionInput">Descrição *</label>
        </b-form-text>
        <b-form-input
          v-model="sdi12ModelForm.DESCRIPTION"
          placeholder="Ex.: Aquacheck"
          aria-describedby="sdi12ModelDescriptionInputLiveHelp sdi12ModelDescriptionInputLiveFeedback"
          :state="sdi12ModelDescriptionState"
          maxlength="150"
          id="sdi12ModelDescriptionInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!sdi12ModelDescriptionState"
          id="sdi12ModelDescriptionInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <b-form-text id="sdi12ModelMeasInputLiveHelp">
          <label for="sdi12ModelMeasInput">Comando de medição (meas) *</label>
        </b-form-text>
        <b-form-input
          v-model="sdi12ModelForm.MEAS"
          placeholder="Ex.: 01 ou !24"
          aria-describedby="sdi12ModelMeasInputLiveHelp sdi12ModelMeasInputLiveFeedback"
          :state="sdi12ModelMeasState"
          maxlength="16"
          id="sdi12ModelMeasInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!sdi12ModelMeasState"
          id="sdi12ModelMeasInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <b-form-text id="sdi12ModelStartInputLiveHelp">
          <label for="sdi12ModelStartInput">Início do dado (start) *</label>
        </b-form-text>
        <b-form-input
          v-model="sdi12ModelForm.START"
          type="number"
          min="0"
          placeholder="Início do dado *"
          aria-describedby="sdi12ModelStartInputLiveHelp sdi12ModelStartInputLiveFeedback"
          :state="sdi12ModelStartState"
          id="sdi12ModelStartInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!sdi12ModelStartState"
          id="sdi12ModelStartInputLiveFeedback"
        >
          Valor inválido.
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>

    <b-modal
      ref="deleteSDI12Model"
      centered
      hide-header
      no-close-on-backdrop
      ok-title="Deletar"
      ok-variant="danger"
      @ok="confirmDeleteSDI12Model"
      cancel-title="Cancelar"
      @cancel="resetSDI12ModelPage"
    >
      <h4>{{ sdi12ModelTitleDialog }}</h4>
    </b-modal>

    <b-modal
      ref="formSweepConfig"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetSweepConfigPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitSweepConfig"
      size="sm"
    >
      <h6>{{ sweepConfigTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitSweepConfig">
        <b-form-text id="sweepConfigDescriptionText" class="mb-2">
          {{ sweepConfigSelected.DESCRIPTION }}
        </b-form-text>
        <b-form-radio-group
          v-if="sweepConfigSelected.TYPE == 'boolean'"
          v-model="sweepConfigForm.VALUE"
          :options="[
            { text: 'Habilitado', value: '1' },
            { text: 'Desabilitado', value: '0' },
          ]"
          stacked
        ></b-form-radio-group>
        <b-form-input
          v-else
          v-model="sweepConfigForm.VALUE"
          :type="sweepConfigSelected.TYPE == 'string' ? 'text' : 'number'"
          :step="sweepConfigSelected.TYPE == 'decimal' ? '0.1' : '1'"
          placeholder="Valor *"
          aria-describedby="sweepConfigValueInputLiveFeedback"
          :state="sweepConfigValueState"
          id="sweepConfigValueInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="sweepConfigSelected.TYPE != 'boolean' && !sweepConfigValueState"
          id="sweepConfigValueInputLiveFeedback"
        >
          Valor inválido.
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>

    <b-modal
      ref="formSweepOverride"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetSweepOverridePage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitSweepOverride"
      size="sm"
    >
      <h6>{{ sweepOverrideTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitSweepOverride">
        <b-form-text id="sweepOverrideSensorModelInputLiveHelp">
          <label for="sweepOverrideSensorModelInput"
            >Modelo do sensor *</label
          >
        </b-form-text>
        <b-form-input
          v-model="sweepOverrideForm.SENSOR_MODEL"
          placeholder="Ex.: STD-M"
          aria-describedby="sweepOverrideSensorModelInputLiveHelp sweepOverrideSensorModelInputLiveFeedback"
          :state="sweepOverrideSensorModelState"
          maxlength="50"
          id="sweepOverrideSensorModelInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!sweepOverrideSensorModelState"
          id="sweepOverrideSensorModelInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <b-form-text id="sweepOverrideDevModelInputLiveHelp">
          <label for="sweepOverrideDevModelInput">Modelo do DIR *</label>
        </b-form-text>
        <b-form-input
          v-model="sweepOverrideForm.DEV_MODEL"
          placeholder="Ex.: DIR_PS"
          aria-describedby="sweepOverrideDevModelInputLiveHelp sweepOverrideDevModelInputLiveFeedback"
          :state="sweepOverrideDevModelState"
          maxlength="50"
          id="sweepOverrideDevModelInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!sweepOverrideDevModelState"
          id="sweepOverrideDevModelInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <b-form-text id="sweepOverrideIntervalInputLiveHelp">
          <label for="sweepOverrideIntervalInput"
            >Intervalo (segundos) *</label
          >
        </b-form-text>
        <b-form-input
          v-model="sweepOverrideForm.INTERVAL"
          type="number"
          min="0"
          max="3600"
          step="0.1"
          placeholder="0-3600 segundos *"
          aria-describedby="sweepOverrideIntervalInputLiveHelp sweepOverrideIntervalInputLiveFeedback"
          :state="sweepOverrideIntervalState"
          id="sweepOverrideIntervalInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!sweepOverrideIntervalState"
          id="sweepOverrideIntervalInputLiveFeedback"
        >
          Valor inválido.
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>

    <b-modal
      ref="deleteSweepOverride"
      centered
      hide-header
      no-close-on-backdrop
      ok-title="Deletar"
      ok-variant="danger"
      @ok="confirmDeleteSweepOverride"
      cancel-title="Cancelar"
      @cancel="resetSweepOverridePage"
    >
      <h4>{{ sweepOverrideTitleDialog }}</h4>
    </b-modal>

    <b-modal
      ref="formRadioConfig"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetRadioConfigPage"
      ok-title="Salvar"
      ok-variant="3v3"
      @ok="submitRadioConfig"
      size="sm"
    >
      <h6>{{ radioConfigTitleDialog }}</h6>
      <b-form novalidate @keyup.enter="submitRadioConfig">
        <b-form-text id="radioConfigDescriptionText" class="mb-2">
          {{ radioConfigSelected.DESCRIPTION }}
        </b-form-text>
        <b-form-radio-group
          v-if="radioConfigSelected.TYPE == 'boolean'"
          v-model="radioConfigForm.VALUE"
          :options="[
            { text: 'Habilitado', value: '1' },
            { text: 'Desabilitado', value: '0' },
          ]"
          stacked
        ></b-form-radio-group>
        <b-form-input
          v-else
          v-model="radioConfigForm.VALUE"
          :type="radioConfigSelected.TYPE == 'string' ? 'text' : 'number'"
          :step="radioConfigSelected.TYPE == 'decimal' ? '0.1' : '1'"
          placeholder="Valor *"
          aria-describedby="radioConfigValueInputLiveFeedback"
          :state="radioConfigValueState"
          id="radioConfigValueInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="radioConfigSelected.TYPE != 'boolean' && !radioConfigValueState"
          id="radioConfigValueInputLiveFeedback"
        >
          Valor inválido.
        </b-form-invalid-feedback>
        <p />
      </b-form>
    </b-modal>

    <b-modal
      ref="updateFirmwareConfirm"
      centered
      hide-header
      no-close-on-backdrop
      ok-title="Atualizar"
      ok-variant="danger"
      @ok="submitUpdateFirmware"
      cancel-title="Cancelar"
    >
      <h4>Atualizar firmware para {{ selectedFirmwareRelease }}?</h4>
      <p>O serviço do firmware (fw_cir) será reiniciado durante a atualização.</p>
    </b-modal>

    <b-modal
      ref="uploadFirmwareModal"
      centered
      hide-header
      no-close-on-backdrop
      cancel-title="Cancelar"
      @cancel="resetUploadFirmwareForm"
      ok-title="Enviar"
      ok-variant="danger"
      :ok-disabled="!uploadFirmwareValid || uploadingFirmware"
      @ok="submitUploadFirmware"
      size="sm"
    >
      <h5>Upload manual de firmware</h5>
      <b-form-text class="mb-2">
        Envia o sir.bin direto da sua máquina — use quando o CIR não tem
        acesso à internet pra buscar a lista de versões. O serviço do
        firmware (fw_cir) será reiniciado durante a atualização.
      </b-form-text>
      <b-form novalidate>
        <b-form-text id="uploadFirmwareVersionInputLiveHelp">
          <label for="uploadFirmwareVersionInput">Versão *</label>
        </b-form-text>
        <b-form-input
          v-model="uploadFirmwareForm.version"
          placeholder="Ex.: v5.15.14"
          aria-describedby="uploadFirmwareVersionInputLiveHelp uploadFirmwareVersionInputLiveFeedback"
          :state="uploadFirmwareVersionState"
          maxlength="50"
          id="uploadFirmwareVersionInput"
        >
        </b-form-input>
        <b-form-invalid-feedback
          v-if="!uploadFirmwareVersionState"
          id="uploadFirmwareVersionInputLiveFeedback"
        >
          Campo obrigatório.
        </b-form-invalid-feedback>
        <b-form-text id="uploadFirmwareFileInputLiveHelp" class="mt-2">
          <label for="uploadFirmwareFileInput">Arquivo sir.bin *</label>
        </b-form-text>
        <input
          type="file"
          id="uploadFirmwareFileInput"
          ref="uploadFirmwareFile"
          class="upload-firmware-file-input"
          @change="chooseFirmwareFile"
        />
        <div class="mt-1" v-if="uploadFirmwareForm.file">
          <strong>Arquivo:</strong> {{ uploadFirmwareForm.file.name }} ({{
            (uploadFirmwareForm.file.size / 1024).toFixed(0)
          }}
          KB)
        </div>
        <p />
      </b-form>
    </b-modal>

    <div :class="computedClass">
      <div class="col-xs-12 p-xs-2 p-sm-0 p-xl-0">
        <div :class="computedClassHeader">Configuração / Firmware</div>
        <div class="row start-xs mt-2 col-xs-12 m-0">
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Atualização de firmware</h4>
            </div>
            <p><strong>Versão instalada:</strong> {{ fwCirVersion }}</p>
            <b-form-text id="firmwareReleaseSelectLiveHelp">
              <label for="firmwareReleaseSelect">Versão disponível</label>
            </b-form-text>
            <b-form-select
              v-model="selectedFirmwareRelease"
              :options="firmwareReleaseOptions"
              id="firmwareReleaseSelect"
            ></b-form-select>
            <div slot="footer" class="row around-xs">
              <b-btn
                size="sm"
                variant="3v3"
                :disabled="!selectedFirmwareRelease || updatingFirmware"
                @click="confirmUpdateFirmware"
              >
                {{ updatingFirmware ? "Atualizando..." : "Atualizar" }}
              </b-btn>
              <b-btn size="sm" variant="3v3" @click="openUploadFirmwareModal"
                >Upload manual...</b-btn
              >
            </div>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Configurações gerais</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              class="clickable-rows"
              :items="generalConfigs"
              :fields="generalConfigFields"
              @row-clicked="editGeneralConfig"
            >
            </b-table>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Configurações de automação</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              class="clickable-rows"
              :items="automationConfigs"
              :fields="automationConfigFields"
              @row-clicked="editAutomationConfig"
            >
            </b-table>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Configurações de protocolo</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              class="clickable-rows"
              :items="protocolConfigs"
              :fields="protocolConfigFields"
              @row-clicked="editProtocolConfig"
            >
            </b-table>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Configuração Modbus RTU</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              class="clickable-rows"
              :items="modbusConfigs"
              :fields="modbusConfigFields"
              @row-clicked="editModbusConfig"
            >
            </b-table>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Modelos Modbus RTU</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              :items="modbusModels"
              :fields="modbusModelFields"
            >
              <template slot="HEAD_CHECK">
                <b-form-checkbox
                  @click.native.prevent="toggleAllModbusModel"
                  v-model="allModbusModelSelected"
                ></b-form-checkbox>
              </template>
              <template slot="CHECK" slot-scope="row">
                <b-form-checkbox
                  :value="row.item"
                  v-model="selModbusModel"
                ></b-form-checkbox>
              </template>
            </b-table>
            <div slot="footer" class="row around-xs">
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selModbusModel.length == 1"
                @click="editModbusModel"
                ><pencil-icon title=""
              /></b-btn>
              <b-btn size="sm" variant="3v3" @click="addModbusModel"
                ><plus-icon title=""
              /></b-btn>
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selModbusModel.length"
                @click="delModbusModel"
                ><delete-icon title=""
              /></b-btn>
            </div>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Configuração I²C</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              class="clickable-rows"
              :items="i2cConfigs"
              :fields="i2cConfigFields"
              @row-clicked="editI2CConfig"
            >
            </b-table>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Configuração SDI-12</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              class="clickable-rows"
              :items="sdi12Configs"
              :fields="sdi12ConfigFields"
              @row-clicked="editSDI12Config"
            >
            </b-table>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Modelos SDI-12</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              :items="sdi12Models"
              :fields="sdi12ModelFields"
            >
              <template slot="HEAD_CHECK">
                <b-form-checkbox
                  @click.native.prevent="toggleAllSDI12Model"
                  v-model="allSDI12ModelSelected"
                ></b-form-checkbox>
              </template>
              <template slot="CHECK" slot-scope="row">
                <b-form-checkbox
                  :value="row.item"
                  v-model="selSDI12Model"
                ></b-form-checkbox>
              </template>
            </b-table>
            <div slot="footer" class="row around-xs">
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selSDI12Model.length == 1"
                @click="editSDI12Model"
                ><pencil-icon title=""
              /></b-btn>
              <b-btn size="sm" variant="3v3" @click="addSDI12Model"
                ><plus-icon title=""
              /></b-btn>
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selSDI12Model.length"
                @click="delSDI12Model"
                ><delete-icon title=""
              /></b-btn>
            </div>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Configuração de varredura</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              class="clickable-rows"
              :items="sweepConfigs"
              :fields="sweepConfigFields"
              @row-clicked="editSweepConfig"
            >
            </b-table>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Overrides de varredura</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              :items="sweepOverrides"
              :fields="sweepOverrideFields"
            >
              <template slot="HEAD_CHECK">
                <b-form-checkbox
                  @click.native.prevent="toggleAllSweepOverride"
                  v-model="allSweepOverrideSelected"
                ></b-form-checkbox>
              </template>
              <template slot="CHECK" slot-scope="row">
                <b-form-checkbox
                  :value="row.item"
                  v-model="selSweepOverride"
                ></b-form-checkbox>
              </template>
            </b-table>
            <div slot="footer" class="row around-xs">
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selSweepOverride.length == 1"
                @click="editSweepOverride"
                ><pencil-icon title=""
              /></b-btn>
              <b-btn size="sm" variant="3v3" @click="addSweepOverride"
                ><plus-icon title=""
              /></b-btn>
              <b-btn
                size="sm"
                variant="3v3"
                v-if="selSweepOverride.length"
                @click="delSweepOverride"
                ><delete-icon title=""
              /></b-btn>
            </div>
          </b-card>
          </div>
          <div class="col-xs-12 col-md-6 col-xl-4 p-2">
          <b-card class="h-100">
            <div slot="header">
              <h4>Configuração de rádio</h4>
            </div>
            <b-table
              hover
              striped
              small
              responsive
              class="clickable-rows"
              :items="radioConfigs"
              :fields="radioConfigFields"
              @row-clicked="editRadioConfig"
            >
            </b-table>
          </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { session, info } from "@/api";

export default {
  name: "firmware-config",
  props: {
    mobile: Boolean,
  },
  created() {
    this.attFwCirVersion();
    this.attFirmwareReleases();
    this.attGeneralConfigList();
    this.attAutomationConfigList();
    this.attProtocolConfigList();
    this.attModbusConfigList();
    this.attModbusModelList();
    this.attI2CConfigList();
    this.attSDI12ConfigList();
    this.attSDI12ModelList();
    this.attSweepConfigList();
    this.attSweepOverrideList();
    this.attRadioConfigList();
  },
  data() {
    return {
      fwCirVersion: "-",
      firmwareReleases: [],
      selectedFirmwareRelease: null,
      updatingFirmware: false,
      uploadFirmwareForm: {
        version: null,
        file: null,
      },
      uploadingFirmware: false,
      generalConfigFields: [
        {
          key: "LABEL",
          label: "Parâmetro",
        },
        {
          key: "VALUE",
          label: "Valor",
        },
      ],
      automationConfigFields: [
        {
          key: "LABEL",
          label: "Parâmetro",
        },
        {
          key: "VALUE",
          label: "Valor",
        },
      ],
      protocolConfigFields: [
        {
          key: "LABEL",
          label: "Parâmetro",
        },
        {
          key: "VALUE",
          label: "Valor",
        },
      ],
      modbusConfigFields: [
        {
          key: "LABEL",
          label: "Parâmetro",
        },
        {
          key: "VALUE",
          label: "Valor",
        },
      ],
      modbusModelFields: [
        {
          key: "CHECK",
          label: "",
        },
        {
          key: "NAME",
          label: "Nome",
        },
        {
          key: "DESCRIPTION",
          label: "Descrição",
        },
      ],
      modbusModelBaudrateOptions: [
        { value: 0, text: "19200 bps" },
        { value: 1, text: "9600 bps" },
        { value: 2, text: "4800 bps" },
        { value: 3, text: "2400 bps" },
        { value: 4, text: "1200 bps" },
      ],
      i2cConfigFields: [
        {
          key: "LABEL",
          label: "Parâmetro",
        },
        {
          key: "VALUE",
          label: "Valor",
        },
      ],
      sdi12ConfigFields: [
        {
          key: "LABEL",
          label: "Parâmetro",
        },
        {
          key: "VALUE",
          label: "Valor",
        },
      ],
      sdi12ModelFields: [
        {
          key: "CHECK",
          label: "",
        },
        {
          key: "NAME",
          label: "Nome",
        },
        {
          key: "DESCRIPTION",
          label: "Descrição",
        },
      ],
      sweepConfigFields: [
        {
          key: "LABEL",
          label: "Parâmetro",
        },
        {
          key: "VALUE",
          label: "Valor",
        },
      ],
      sweepOverrideFields: [
        {
          key: "CHECK",
          label: "",
        },
        {
          key: "SENSOR_MODEL",
          label: "Modelo do sensor",
        },
        {
          key: "DEV_MODEL",
          label: "Modelo do DIR",
        },
      ],
      radioConfigFields: [
        {
          key: "LABEL",
          label: "Parâmetro",
        },
        {
          key: "VALUE",
          label: "Valor",
        },
      ],
      generalConfigs: [],
      automationConfigs: [],
      protocolConfigs: [],
      modbusConfigs: [],
      modbusModels: [],
      i2cConfigs: [],
      sdi12Configs: [],
      sdi12Models: [],
      sweepConfigs: [],
      sweepOverrides: [],
      radioConfigs: [],
      allModbusModelSelected: false,
      allSDI12ModelSelected: false,
      allSweepOverrideSelected: false,
      selModbusModel: [],
      selSDI12Model: [],
      selSweepOverride: [],
      generalConfigSelected: {},
      automationConfigSelected: {},
      protocolConfigSelected: {},
      modbusConfigSelected: {},
      modbusModelSelected: {},
      i2cConfigSelected: {},
      sdi12ConfigSelected: {},
      sdi12ModelSelected: {},
      sweepConfigSelected: {},
      sweepOverrideSelected: {},
      radioConfigSelected: {},
      generalConfigForm: {
        VALUE: null,
      },
      automationConfigForm: {
        VALUE: null,
      },
      protocolConfigForm: {
        VALUE: null,
      },
      modbusConfigForm: {
        VALUE: null,
      },
      modbusModelForm: {
        NAME: null,
        DESCRIPTION: null,
        BAUDRATE: 0,
        PID: "0",
        TIMEOUT: null,
      },
      i2cConfigForm: {
        VALUE: null,
      },
      sdi12ConfigForm: {
        VALUE: null,
      },
      sdi12ModelForm: {
        NAME: null,
        DESCRIPTION: null,
        MEAS: null,
        START: null,
      },
      sweepConfigForm: {
        VALUE: null,
      },
      sweepOverrideForm: {
        SENSOR_MODEL: null,
        DEV_MODEL: null,
        INTERVAL: null,
      },
      radioConfigForm: {
        VALUE: null,
      },
      generalConfigTitleDialog: "",
      automationConfigTitleDialog: "",
      protocolConfigTitleDialog: "",
      modbusConfigTitleDialog: "",
      modbusModelTitleDialog: "",
      i2cConfigTitleDialog: "",
      sdi12ConfigTitleDialog: "",
      sdi12ModelTitleDialog: "",
      sweepConfigTitleDialog: "",
      sweepOverrideTitleDialog: "",
      radioConfigTitleDialog: "",
    };
  },
  watch: {
    selModbusModel() {
      this.allModbusModelSelected =
        this.selModbusModel.length == this.modbusModels.length;
    },
    selSDI12Model() {
      this.allSDI12ModelSelected =
        this.selSDI12Model.length == this.sdi12Models.length;
    },
    selSweepOverride() {
      this.allSweepOverrideSelected =
        this.selSweepOverride.length == this.sweepOverrides.length;
    },
  },
  computed: {
    computedClass() {
      if (this.mobile) {
        return "row mobile-header p-2";
      }
      return "row desktop-header w-100 mt-2 col-xs-12 ml-0 mr-0 p-0";
    },
    computedClassHeader() {
      if (this.mobile) {
        return "page-title config-title-mobile col-xs-12  mt-0";
      }
      return "page-title config-title col-xs-12  mt-2";
    },
    firmwareReleaseOptions() {
      return this.firmwareReleases.map((release) => ({
        value: release.tag,
        text: release.tag,
      }));
    },
    uploadFirmwareVersionState() {
      return (
        this.uploadFirmwareForm.version != "" &&
        this.uploadFirmwareForm.version != null
      );
    },
    uploadFirmwareValid() {
      return this.uploadFirmwareVersionState && !!this.uploadFirmwareForm.file;
    },
    generalConfigValueState() {
      const value = this.generalConfigForm.VALUE;
      const type = this.generalConfigSelected.TYPE;
      if (value == null || value === "") return false;
      if (type == "integer") return /^\d+$/.test(value);
      if (type == "decimal") return /^\d+(\.\d+)?$/.test(value);
      return true;
    },
    automationConfigValueState() {
      const value = this.automationConfigForm.VALUE;
      const type = this.automationConfigSelected.TYPE;
      const { MIN_VALUE, MAX_VALUE } = this.automationConfigSelected;
      if (value == null || value === "") return false;
      if (type == "integer" && !/^\d+$/.test(value)) return false;
      if (type == "decimal" && !/^\d+(\.\d+)?$/.test(value)) return false;
      if (type == "integer" || type == "decimal") {
        const num = Number(value);
        if (MIN_VALUE != null && num < Number(MIN_VALUE)) return false;
        if (MAX_VALUE != null && num > Number(MAX_VALUE)) return false;
      }
      return true;
    },
    automationConfigRangeHint() {
      const { MIN_VALUE, MAX_VALUE } = this.automationConfigSelected;
      if (MIN_VALUE == null && MAX_VALUE == null) return "";
      if (MIN_VALUE != null && MAX_VALUE != null) return ` (faixa: ${MIN_VALUE} a ${MAX_VALUE})`;
      if (MIN_VALUE != null) return ` (mínimo: ${MIN_VALUE})`;
      return ` (máximo: ${MAX_VALUE})`;
    },
    protocolConfigValueState() {
      const value = this.protocolConfigForm.VALUE;
      const type = this.protocolConfigSelected.TYPE;
      if (value == null || value === "") return false;
      if (type == "integer") return /^\d+$/.test(value);
      if (type == "decimal") return /^\d+(\.\d+)?$/.test(value);
      return true;
    },
    modbusConfigValueState() {
      const value = this.modbusConfigForm.VALUE;
      const type = this.modbusConfigSelected.TYPE;
      if (value == null || value === "") return false;
      if (type == "integer") return /^\d+$/.test(value);
      if (type == "decimal") return /^\d+(\.\d+)?$/.test(value);
      return true;
    },
    modbusModelNameState() {
      return (
        this.modbusModelForm.NAME != "" && this.modbusModelForm.NAME != null
      );
    },
    modbusModelDescriptionState() {
      return (
        this.modbusModelForm.DESCRIPTION != "" &&
        this.modbusModelForm.DESCRIPTION != null
      );
    },
    modbusModelTimeoutState() {
      const value = this.modbusModelForm.TIMEOUT;
      if (value == null || value === "") return false;
      return /^\d+$/.test(value) && Number(value) <= 5000;
    },
    i2cConfigValueState() {
      const value = this.i2cConfigForm.VALUE;
      if (value == null || value === "") return false;
      return /^0x[0-9a-fA-F]{1,2}$/.test(value);
    },
    sdi12ConfigValueState() {
      const value = this.sdi12ConfigForm.VALUE;
      const type = this.sdi12ConfigSelected.TYPE;
      if (value == null || value === "") return false;
      if (type == "integer") return /^\d+$/.test(value);
      if (type == "decimal") return /^\d+(\.\d+)?$/.test(value);
      return true;
    },
    sdi12ModelNameState() {
      return (
        this.sdi12ModelForm.NAME != "" && this.sdi12ModelForm.NAME != null
      );
    },
    sdi12ModelDescriptionState() {
      return (
        this.sdi12ModelForm.DESCRIPTION != "" &&
        this.sdi12ModelForm.DESCRIPTION != null
      );
    },
    sdi12ModelMeasState() {
      return (
        this.sdi12ModelForm.MEAS != "" && this.sdi12ModelForm.MEAS != null
      );
    },
    sdi12ModelStartState() {
      const value = this.sdi12ModelForm.START;
      if (value == null || value === "") return false;
      return /^\d+$/.test(value);
    },
    sweepConfigValueState() {
      const value = this.sweepConfigForm.VALUE;
      const type = this.sweepConfigSelected.TYPE;
      if (value == null || value === "") return false;
      if (type == "integer") return /^\d+$/.test(value);
      if (type == "decimal") return /^\d+(\.\d+)?$/.test(value);
      return true;
    },
    sweepOverrideSensorModelState() {
      return (
        this.sweepOverrideForm.SENSOR_MODEL != "" &&
        this.sweepOverrideForm.SENSOR_MODEL != null
      );
    },
    sweepOverrideDevModelState() {
      return (
        this.sweepOverrideForm.DEV_MODEL != "" &&
        this.sweepOverrideForm.DEV_MODEL != null
      );
    },
    sweepOverrideIntervalState() {
      const value = this.sweepOverrideForm.INTERVAL;
      if (value == null || value === "") return false;
      return /^\d+(\.\d+)?$/.test(value);
    },
    radioConfigValueState() {
      const value = this.radioConfigForm.VALUE;
      const type = this.radioConfigSelected.TYPE;
      if (value == null || value === "") return false;
      if (type == "integer") return /^\d+$/.test(value);
      if (type == "decimal") return /^\d+(\.\d+)?$/.test(value);
      return true;
    },
  },
  methods: {
    attFwCirVersion() {
      info
        .fwCirVersion()
        .then((version) => {
          this.fwCirVersion = version || "-";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    attFirmwareReleases() {
      info
        .firmwareReleases()
        .then((releases) => {
          this.firmwareReleases = releases;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao buscar as releases de firmware disponíveis. Recarregue a página."
          );
          console.log(err);
        });
    },
    confirmUpdateFirmware() {
      this.$refs.updateFirmwareConfirm.show();
    },
    submitUpdateFirmware() {
      this.updatingFirmware = true;
      info
        .updateFirmware({ TAG: this.selectedFirmwareRelease })
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attFwCirVersion();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro ao atualizar o firmware.");
        })
        .finally(() => {
          this.updatingFirmware = false;
        });
    },
    openUploadFirmwareModal() {
      this.resetUploadFirmwareForm();
      this.$refs.uploadFirmwareModal.show();
    },
    chooseFirmwareFile() {
      let file = this.$refs.uploadFirmwareFile.files[0];
      if (!window.FileReader) {
        alert("O navegador não permite a ação.");
        return;
      }
      this.uploadFirmwareForm.file = file;
    },
    submitUploadFirmware() {
      this.uploadingFirmware = true;
      let formData = new FormData();
      formData.append("file", this.uploadFirmwareForm.file);
      formData.append("VERSION", this.uploadFirmwareForm.version);
      info
        .uploadFirmware(formData)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attFwCirVersion();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro ao atualizar o firmware.");
        })
        .finally(() => {
          this.uploadingFirmware = false;
        });
      this.$refs.uploadFirmwareModal.hide();
    },
    resetUploadFirmwareForm() {
      this.uploadFirmwareForm = { version: null, file: null };
      if (this.$refs.uploadFirmwareFile) this.$refs.uploadFirmwareFile.value = "";
    },
    editGeneralConfig(item) {
      this.generalConfigSelected = item;
      this.generalConfigTitleDialog = `Editar ${this.generalConfigSelected.LABEL}`;
      this.generalConfigForm = {
        VALUE: this.generalConfigSelected.VALUE,
      };
      this.$refs.formGeneralConfig.show();
    },
    submitGeneralConfig() {
      let data = {
        ID: this.generalConfigSelected.ID,
        VALUE: this.generalConfigForm.VALUE,
      };
      session
        .editGeneralConfig(data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attGeneralConfigList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formGeneralConfig.hide();
    },
    attGeneralConfigList() {
      session
        .getGeneralConfig()
        .then((generalConfigs) => {
          this.generalConfigs = generalConfigs;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar as configurações gerais. Recarregue a página."
          );
          console.log(err);
        });
      this.resetGeneralConfigPage();
    },
    resetGeneralConfigPage() {
      this.generalConfigForm = {
        VALUE: null,
      };
      this.generalConfigSelected = {};
      this.generalConfigTitleDialog = "";
    },
    editAutomationConfig(item) {
      this.automationConfigSelected = item;
      this.automationConfigTitleDialog = `Editar ${this.automationConfigSelected.LABEL}`;
      this.automationConfigForm = {
        VALUE: this.automationConfigSelected.VALUE,
      };
      this.$refs.formAutomationConfig.show();
    },
    submitAutomationConfig() {
      let data = {
        ID: this.automationConfigSelected.ID,
        VALUE: this.automationConfigForm.VALUE,
      };
      session
        .editAutomationConfig(data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attAutomationConfigList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formAutomationConfig.hide();
    },
    attAutomationConfigList() {
      session
        .getAutomationConfig()
        .then((automationConfigs) => {
          this.automationConfigs = automationConfigs;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar as configurações de automação. Recarregue a página."
          );
          console.log(err);
        });
      this.resetAutomationConfigPage();
    },
    resetAutomationConfigPage() {
      this.automationConfigForm = {
        VALUE: null,
      };
      this.automationConfigSelected = {};
      this.automationConfigTitleDialog = "";
    },
    editProtocolConfig(item) {
      this.protocolConfigSelected = item;
      this.protocolConfigTitleDialog = `Editar ${this.protocolConfigSelected.LABEL}`;
      this.protocolConfigForm = {
        VALUE: this.protocolConfigSelected.VALUE,
      };
      this.$refs.formProtocolConfig.show();
    },
    submitProtocolConfig() {
      let data = {
        ID: this.protocolConfigSelected.ID,
        VALUE: this.protocolConfigForm.VALUE,
      };
      session
        .editProtocolConfig(data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attProtocolConfigList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formProtocolConfig.hide();
    },
    attProtocolConfigList() {
      session
        .getProtocolConfig()
        .then((protocolConfigs) => {
          this.protocolConfigs = protocolConfigs;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar as configurações de protocolo. Recarregue a página."
          );
          console.log(err);
        });
      this.resetProtocolConfigPage();
    },
    resetProtocolConfigPage() {
      this.protocolConfigForm = {
        VALUE: null,
      };
      this.protocolConfigSelected = {};
      this.protocolConfigTitleDialog = "";
    },
    editModbusConfig(item) {
      this.modbusConfigSelected = item;
      this.modbusConfigTitleDialog = `Editar ${this.modbusConfigSelected.LABEL}`;
      this.modbusConfigForm = {
        VALUE: this.modbusConfigSelected.VALUE,
      };
      this.$refs.formModbusConfig.show();
    },
    submitModbusConfig() {
      let data = {
        ID: this.modbusConfigSelected.ID,
        VALUE: this.modbusConfigForm.VALUE,
      };
      session
        .editModbusConfig(data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attModbusConfigList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formModbusConfig.hide();
    },
    attModbusConfigList() {
      session
        .getModbusConfig()
        .then((modbusConfigs) => {
          this.modbusConfigs = modbusConfigs;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar a configuração Modbus RTU. Recarregue a página."
          );
          console.log(err);
        });
      this.resetModbusConfigPage();
    },
    resetModbusConfigPage() {
      this.modbusConfigForm = {
        VALUE: null,
      };
      this.modbusConfigSelected = {};
      this.modbusConfigTitleDialog = "";
    },
    toggleAllModbusModel() {
      this.allModbusModelSelected = !this.allModbusModelSelected;
      if (this.selModbusModel.length < this.modbusModels.length) {
        this.selModbusModel = this.modbusModels.slice();
      } else if (this.selModbusModel.length == this.modbusModels.length) {
        this.selModbusModel = [];
      }
    },
    addModbusModel() {
      this.resetModbusModelPage();
      this.modbusModelTitleDialog = "Adicionar modelo Modbus RTU";
      this.$refs.formModbusModel.show();
    },
    editModbusModel() {
      this.modbusModelSelected = this.selModbusModel[0];
      this.modbusModelTitleDialog = `Editar modelo ${this.modbusModelSelected.NAME}`;
      this.modbusModelForm = {
        NAME: this.modbusModelSelected.NAME,
        DESCRIPTION: this.modbusModelSelected.DESCRIPTION,
        BAUDRATE: this.modbusModelSelected.BAUDRATE,
        PID: this.modbusModelSelected.PID,
        TIMEOUT: this.modbusModelSelected.TIMEOUT,
      };
      this.$refs.formModbusModel.show();
    },
    delModbusModel() {
      this.modbusModelSelected = { items: this.selModbusModel };
      this.modbusModelTitleDialog =
        this.selModbusModel.length +
        (this.selModbusModel.length == 1
          ? " modelo Modbus RTU será excluído."
          : " modelos Modbus RTU serão excluídos.");
      this.$refs.deleteModbusModel.show();
    },
    confirmDeleteModbusModel() {
      session
        .deleteModbusModel(this.modbusModelSelected.items)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attModbusModelList();
        })
        .catch((err) => console.log(err));
    },
    submitModbusModel() {
      let data = {
        ID: this.modbusModelSelected.ID ? this.modbusModelSelected.ID : null,
        NAME: this.modbusModelForm.NAME,
        DESCRIPTION: this.modbusModelForm.DESCRIPTION,
        BAUDRATE: this.modbusModelForm.BAUDRATE,
        PID: this.modbusModelForm.PID,
        TIMEOUT: this.modbusModelForm.TIMEOUT,
      };
      let request = data.ID
        ? session.editModbusModel(data)
        : session.addModbusModel(data);

      request
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attModbusModelList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formModbusModel.hide();
    },
    attModbusModelList() {
      session
        .getModbusModels()
        .then((modbusModels) => {
          this.modbusModels = modbusModels;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar lista de modelos Modbus RTU. Recarregue a página."
          );
          console.log(err);
        });
      this.resetModbusModelPage();
    },
    resetModbusModelPage() {
      this.modbusModelForm = {
        NAME: null,
        DESCRIPTION: null,
        BAUDRATE: 0,
        PID: "0",
        TIMEOUT: null,
      };
      this.allModbusModelSelected = false;
      this.selModbusModel = [];
      this.modbusModelSelected = {};
      this.modbusModelTitleDialog = "";
    },
    editI2CConfig(item) {
      this.i2cConfigSelected = item;
      this.i2cConfigTitleDialog = `Editar ${this.i2cConfigSelected.LABEL}`;
      this.i2cConfigForm = {
        VALUE: this.i2cConfigSelected.VALUE,
      };
      this.$refs.formI2CConfig.show();
    },
    submitI2CConfig() {
      let data = {
        ID: this.i2cConfigSelected.ID,
        VALUE: this.i2cConfigForm.VALUE,
      };
      session
        .editI2CConfig(data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attI2CConfigList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formI2CConfig.hide();
    },
    attI2CConfigList() {
      session
        .getI2CConfig()
        .then((i2cConfigs) => {
          this.i2cConfigs = i2cConfigs;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar a configuração I²C. Recarregue a página."
          );
          console.log(err);
        });
      this.resetI2CConfigPage();
    },
    resetI2CConfigPage() {
      this.i2cConfigForm = {
        VALUE: null,
      };
      this.i2cConfigSelected = {};
      this.i2cConfigTitleDialog = "";
    },
    editSDI12Config(item) {
      this.sdi12ConfigSelected = item;
      this.sdi12ConfigTitleDialog = `Editar ${this.sdi12ConfigSelected.LABEL}`;
      this.sdi12ConfigForm = {
        VALUE: this.sdi12ConfigSelected.VALUE,
      };
      this.$refs.formSDI12Config.show();
    },
    submitSDI12Config() {
      let data = {
        ID: this.sdi12ConfigSelected.ID,
        VALUE: this.sdi12ConfigForm.VALUE,
      };
      session
        .editSDI12Config(data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attSDI12ConfigList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formSDI12Config.hide();
    },
    attSDI12ConfigList() {
      session
        .getSDI12Config()
        .then((sdi12Configs) => {
          this.sdi12Configs = sdi12Configs;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar a configuração SDI-12. Recarregue a página."
          );
          console.log(err);
        });
      this.resetSDI12ConfigPage();
    },
    resetSDI12ConfigPage() {
      this.sdi12ConfigForm = {
        VALUE: null,
      };
      this.sdi12ConfigSelected = {};
      this.sdi12ConfigTitleDialog = "";
    },
    toggleAllSDI12Model() {
      this.allSDI12ModelSelected = !this.allSDI12ModelSelected;
      if (this.selSDI12Model.length < this.sdi12Models.length) {
        this.selSDI12Model = this.sdi12Models.slice();
      } else if (this.selSDI12Model.length == this.sdi12Models.length) {
        this.selSDI12Model = [];
      }
    },
    addSDI12Model() {
      this.resetSDI12ModelPage();
      this.sdi12ModelTitleDialog = "Adicionar modelo SDI-12";
      this.$refs.formSDI12Model.show();
    },
    editSDI12Model() {
      this.sdi12ModelSelected = this.selSDI12Model[0];
      this.sdi12ModelTitleDialog = `Editar modelo ${this.sdi12ModelSelected.NAME}`;
      this.sdi12ModelForm = {
        NAME: this.sdi12ModelSelected.NAME,
        DESCRIPTION: this.sdi12ModelSelected.DESCRIPTION,
        MEAS: this.sdi12ModelSelected.MEAS,
        START: this.sdi12ModelSelected.START,
      };
      this.$refs.formSDI12Model.show();
    },
    delSDI12Model() {
      this.sdi12ModelSelected = { items: this.selSDI12Model };
      this.sdi12ModelTitleDialog =
        this.selSDI12Model.length +
        (this.selSDI12Model.length == 1
          ? " modelo SDI-12 será excluído."
          : " modelos SDI-12 serão excluídos.");
      this.$refs.deleteSDI12Model.show();
    },
    confirmDeleteSDI12Model() {
      session
        .deleteSDI12Model(this.sdi12ModelSelected.items)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attSDI12ModelList();
        })
        .catch((err) => console.log(err));
    },
    submitSDI12Model() {
      let data = {
        ID: this.sdi12ModelSelected.ID ? this.sdi12ModelSelected.ID : null,
        NAME: this.sdi12ModelForm.NAME,
        DESCRIPTION: this.sdi12ModelForm.DESCRIPTION,
        MEAS: this.sdi12ModelForm.MEAS,
        START: this.sdi12ModelForm.START,
      };
      let request = data.ID
        ? session.editSDI12Model(data)
        : session.addSDI12Model(data);

      request
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attSDI12ModelList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formSDI12Model.hide();
    },
    attSDI12ModelList() {
      session
        .getSDI12Models()
        .then((sdi12Models) => {
          this.sdi12Models = sdi12Models;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar lista de modelos SDI-12. Recarregue a página."
          );
          console.log(err);
        });
      this.resetSDI12ModelPage();
    },
    resetSDI12ModelPage() {
      this.sdi12ModelForm = {
        NAME: null,
        DESCRIPTION: null,
        MEAS: null,
        START: null,
      };
      this.allSDI12ModelSelected = false;
      this.selSDI12Model = [];
      this.sdi12ModelSelected = {};
      this.sdi12ModelTitleDialog = "";
    },
    editSweepConfig(item) {
      this.sweepConfigSelected = item;
      this.sweepConfigTitleDialog = `Editar ${this.sweepConfigSelected.LABEL}`;
      this.sweepConfigForm = {
        VALUE: this.sweepConfigSelected.VALUE,
      };
      this.$refs.formSweepConfig.show();
    },
    submitSweepConfig() {
      let data = {
        ID: this.sweepConfigSelected.ID,
        VALUE: this.sweepConfigForm.VALUE,
      };
      session
        .editSweepConfig(data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attSweepConfigList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formSweepConfig.hide();
    },
    attSweepConfigList() {
      session
        .getSweepConfig()
        .then((sweepConfigs) => {
          this.sweepConfigs = sweepConfigs;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar a configuração de varredura. Recarregue a página."
          );
          console.log(err);
        });
      this.resetSweepConfigPage();
    },
    resetSweepConfigPage() {
      this.sweepConfigForm = {
        VALUE: null,
      };
      this.sweepConfigSelected = {};
      this.sweepConfigTitleDialog = "";
    },
    toggleAllSweepOverride() {
      this.allSweepOverrideSelected = !this.allSweepOverrideSelected;
      if (this.selSweepOverride.length < this.sweepOverrides.length) {
        this.selSweepOverride = this.sweepOverrides.slice();
      } else if (this.selSweepOverride.length == this.sweepOverrides.length) {
        this.selSweepOverride = [];
      }
    },
    addSweepOverride() {
      this.resetSweepOverridePage();
      this.sweepOverrideTitleDialog = "Adicionar override de varredura";
      this.$refs.formSweepOverride.show();
    },
    editSweepOverride() {
      this.sweepOverrideSelected = this.selSweepOverride[0];
      this.sweepOverrideTitleDialog = `Editar override de ${this.sweepOverrideSelected.SENSOR_MODEL}`;
      this.sweepOverrideForm = {
        SENSOR_MODEL: this.sweepOverrideSelected.SENSOR_MODEL,
        DEV_MODEL: this.sweepOverrideSelected.DEV_MODEL,
        INTERVAL: this.sweepOverrideSelected.INTERVAL,
      };
      this.$refs.formSweepOverride.show();
    },
    delSweepOverride() {
      this.sweepOverrideSelected = { items: this.selSweepOverride };
      this.sweepOverrideTitleDialog =
        this.selSweepOverride.length +
        (this.selSweepOverride.length == 1
          ? " override de varredura será excluído."
          : " overrides de varredura serão excluídos.");
      this.$refs.deleteSweepOverride.show();
    },
    confirmDeleteSweepOverride() {
      session
        .deleteSweepOverride(this.sweepOverrideSelected.items)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attSweepOverrideList();
        })
        .catch((err) => console.log(err));
    },
    submitSweepOverride() {
      let data = {
        ID: this.sweepOverrideSelected.ID
          ? this.sweepOverrideSelected.ID
          : null,
        SENSOR_MODEL: this.sweepOverrideForm.SENSOR_MODEL
          ? this.sweepOverrideForm.SENSOR_MODEL.toUpperCase()
          : this.sweepOverrideForm.SENSOR_MODEL,
        DEV_MODEL: this.sweepOverrideForm.DEV_MODEL
          ? this.sweepOverrideForm.DEV_MODEL.toUpperCase()
          : this.sweepOverrideForm.DEV_MODEL,
        INTERVAL: this.sweepOverrideForm.INTERVAL,
      };
      let request = data.ID
        ? session.editSweepOverride(data)
        : session.addSweepOverride(data);

      request
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attSweepOverrideList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formSweepOverride.hide();
    },
    attSweepOverrideList() {
      session
        .getSweepOverrides()
        .then((sweepOverrides) => {
          this.sweepOverrides = sweepOverrides;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar lista de overrides de varredura. Recarregue a página."
          );
          console.log(err);
        });
      this.resetSweepOverridePage();
    },
    resetSweepOverridePage() {
      this.sweepOverrideForm = {
        SENSOR_MODEL: null,
        DEV_MODEL: null,
        INTERVAL: null,
      };
      this.allSweepOverrideSelected = false;
      this.selSweepOverride = [];
      this.sweepOverrideSelected = {};
      this.sweepOverrideTitleDialog = "";
    },
    editRadioConfig(item) {
      this.radioConfigSelected = item;
      this.radioConfigTitleDialog = `Editar ${this.radioConfigSelected.LABEL}`;
      this.radioConfigForm = {
        VALUE: this.radioConfigSelected.VALUE,
      };
      this.$refs.formRadioConfig.show();
    },
    submitRadioConfig() {
      let data = {
        ID: this.radioConfigSelected.ID,
        VALUE: this.radioConfigForm.VALUE,
      };
      session
        .editRadioConfig(data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.attRadioConfigList();
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Recarregue a página.");
        });
      this.$refs.formRadioConfig.hide();
    },
    attRadioConfigList() {
      session
        .getRadioConfig()
        .then((radioConfigs) => {
          this.radioConfigs = radioConfigs;
        })
        .catch((err) => {
          alert(
            "Ocorreu um erro ao atualizar a configuração de rádio. Recarregue a página."
          );
          console.log(err);
        });
      this.resetRadioConfigPage();
    },
    resetRadioConfigPage() {
      this.radioConfigForm = {
        VALUE: null,
      };
      this.radioConfigSelected = {};
      this.radioConfigTitleDialog = "";
    },
  },
};
</script>

<style scoped>
.upload-firmware-file-input {
  display: block;
  width: 100%;
  max-width: 100%;
}
.card-body {
  height: 60vh;
  overflow: auto;
}
.mobile-header{
  margin-top: 26px;
}
.config-title {
  max-height: 1.1em;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.config-title-mobile {
  top: 60px;
}
@media screen and (max-width: 767px) {
  .card-text {
    font-size: 0.88em;
  }
}
.card-text > div > p {
  color: var(--text-gray-primary);
}
.clickable-rows >>> tbody tr {
  cursor: pointer;
}
</style>
